﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
import * as nouislider from 'nouislider';



import tpl_generelSetting from './tpl/generelSetting.html';

export default Marionette.ItemView.extend({
    dialogRegion: '#generelSetting_modal',
    errors: [],
    getTemplate: function () {
        return tpl_generelSetting({ model: this.model.toJSON() });
    },
    initialize: function () {
        this.app = this.options.app;
    },
    ui: {
        'generelSetting_btn01': '#generelSetting_btn01',
        'generelSetting_btn02': '#generelSetting_btn02',
        'module_input_HZoomH': '#module_input_HZoomH',
        'module_input_HZoomHValue': '#module_input_HZoomHValue',
        'module_input_HZoomV': '#module_input_HZoomV',
        'module_input_HZoomVValue': '#module_input_HZoomVValue',
        'module_input_VZoomH': '#module_input_VZoomH',
        'module_input_VZoomHValue': '#module_input_VZoomHValue',
        'module_input_VZoomV': '#module_input_VZoomV',
        'module_input_VZoomVValue': '#module_input_VZoomVValue',
        'module_input_WakeLock': '#module_input_WakeLock'
        
    },
    events: {
        'click @ui.generelSetting_btn01': 'onBtn01',
        'click @ui.generelSetting_btn02': 'onBtn02',
        'change @ui.module_input_WakeLock': 'module_input_WakeLockChange'
    },
    onRender: function () {
        var checked = this.model.attributes.WakeLock == 1 ? true : false;
        this.ui.module_input_WakeLock.attr('checked', checked);
    },
    onAttach() {
        var self = this;


        var startSlider1 = document.getElementById('module_input_HZoomH');
        nouislider.create(startSlider1, {
            start: parseInt(self.model.attributes.HZoomH),
            behaviour: 'snap',
            //connect: [true, false],
            range: {
                min: 1,
                max: 200
            },
            step: 1
        });
        startSlider1.noUiSlider.on('set', function (e) {
            self.model.attributes.HZoomH = e[0];
            self.ui.module_input_HZoomHValue.html(resources.X101570 + ': ' + parseInt(e));
        });

        var startSlider2 = document.getElementById('module_input_HZoomV');
        nouislider.create(startSlider2, {
            start: parseInt(self.model.attributes.HZoomV),
            behaviour: 'snap',
            //connect: [true, false],
            range: {
                min: 1,
                max: 200
            },
            step: 1
        });
        startSlider2.noUiSlider.on('set', function (e) {
            self.model.attributes.HZoomV = e[0];
            self.ui.module_input_HZoomVValue.html(resources.X101571 + ': ' + parseInt(e));
        });

        var startSlider3 = document.getElementById('module_input_VZoomH');
        nouislider.create(startSlider3, {
            start: parseInt(self.model.attributes.VZoomH),
            behaviour: 'snap',
            //connect: [true, false],
            range: {
                min: 1,
                max: 200
            },
            step: 1
        });
        startSlider3.noUiSlider.on('set', function (e) {
            self.model.attributes.VZoomH = e[0];
            self.ui.module_input_VZoomHValue.html(resources.X101570 + ': ' + parseInt(e));
        });

        var startSlider4 = document.getElementById('module_input_VZoomV');
        nouislider.create(startSlider4, {
            start: parseInt(self.model.attributes.VZoomV),
            behaviour: 'snap',
            //connect: [true, false],
            range: {
                min: 1,
                max: 200
            },
            step: 1
        });
        startSlider4.noUiSlider.on('set', function (e) {
            self.model.attributes.VZoomV = e[0];
            self.ui.module_input_VZoomVValue.html(resources.X101571 + ': ' + parseInt(e));
        });
    },
    setupEnableType: function () {
    },
    module_input_WakeLockChange: function (event) {
        this.setModel();
    },
    onBtn01: function () {
        var self = this;

        self.setModel();

        var callback = function () {
            self.trigger("dialog:close");
            self.triggerMethod('dialog:btn01clicked', "msg");
        }

        this.validate(callback);
    },
    onBtn02: function () {
        this.triggerMethod('dialog:btn02clicked', "msg");
        this.trigger("dialog:close");
    },
    showErrors: function (errors) {
        _.each(errors, function (error) {
            var controlGroup = this.$('.' + error.name);
            controlGroup.addClass('error');
            controlGroup.find('.help-inline').text(error.message);
        }, this);
    },
    hideErrors: function () {
        this.$('.control-group').removeClass('error');
        this.$('.help-inline').text('');

        this.errors = [];
    },
    validate: function (callback) {
        var self = this;
        this.hideErrors();
        callback();
    },
    setModel: function () {
        var checked = 1;
        this.ui.module_input_WakeLock.is(':checked') ? checked = 1 : checked = 0;
        this.model.set({
            
            WakeLock: checked
        });
    },
    setupCssStyle: function () {
    }
});